import { render, staticRenderFns } from "./ProfileEventList.vue?vue&type=template&id=b3b980ce&scoped=true"
import script from "./ProfileEventList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileEventList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileEventList.vue?vue&type=style&index=0&id=b3b980ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b980ce",
  null
  
)

export default component.exports